import { Injectable } from '@angular/core';
import {CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router} from '@angular/router';
import { Observable } from 'rxjs';
import {AuthenticationService} from "../../_services/auth/authentication.service";
import {PenggunaModel} from "../../_model/auth/authentication.model";

@Injectable({
  providedIn: 'root'
})


export class SkpdGuard implements CanActivate {

  constructor(
    private _router: Router,
    private _authService: AuthenticationService) {
  }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    let pengguna: PenggunaModel =  this._authService.currentUserDetail;
    let defaultYear = localStorage.getItem('defaultYear');
    if (Number(pengguna.otor)>2){
      return true;
    } else {
      this._router.navigate([`${defaultYear}/dashboard`]);
      return false;
    }
  }

}
